import { jsx as _jsx } from "react/jsx-runtime";
import { getQueryClient } from '#pplx/frontend/react-query/queryClient.js';
import { queryClientProviderConfigContext } from '#pplx/frontend/react-query/QueryClientProviderContext.js';
import { QueryClientProvider } from '@tanstack/react-query';
import { useMemo } from 'react';
/**
 * Get a QueryClientProvider instance for the current environment.
 * Uses a singleton QueryClient instance even if remounted.
 * @returns The QueryClientProvider instance
 */
export function Provider({ children, buildVersion = 'local', allowPersist, queryClient: providedQueryClient, }) {
    const canPersist = !!allowPersist;
    const queryClient = providedQueryClient ??
        getQueryClient({
            buildVersion,
            allowPersist: canPersist,
        });
    return (_jsx(queryClientProviderConfigContext.Provider, { value: useMemo(() => ({ allowPersist: canPersist }), [canPersist]), children: _jsx(QueryClientProvider, { client: queryClient, children: children }) }));
}
//# sourceMappingURL=QueryClientProvider.js.map